export const OnCallLogo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 149 15' fill='none' {...props}>
    <path
      d='M34.0811 12.3008V14.2324H42.4514V12.3008H34.0811Z'
      fill='#0D0D0E'
    />
    <path
      d='M31.6718 0.57666V14.2322H29.5417L20.2226 3.63869V14.2322H17.8833V0.57666H20.3938L29.3325 10.7137V0.57666H31.6718Z'
      fill='#0D0D0E'
    />
    <path
      d='M8.49756 0.368408C13.1191 0.368408 16.5044 3.35436 16.5044 7.40536C16.5044 11.4564 13.1191 14.4423 8.49756 14.4423C3.87604 14.4423 0.490723 11.4564 0.490723 7.40536C0.490723 3.35436 3.87604 0.368408 8.49756 0.368408ZM8.49756 2.51753C5.20734 2.51753 2.98216 4.49549 2.98216 7.40536C2.98216 10.3152 5.20734 12.2932 8.49756 12.2932C11.7878 12.2932 14.013 10.3152 14.013 7.40536C14.013 4.49549 11.7878 2.51753 8.49756 2.51753Z'
      fill='#0D0D0E'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M59.0905 5.86245C58.3479 2.61852 55.2675 0.368164 51.2554 0.368164C46.6339 0.368164 43.2485 3.35412 43.2485 7.40512C43.2485 11.4561 46.6339 14.4421 51.2554 14.4421C55.2362 14.4421 58.2999 12.2266 59.0728 9.02331H56.5156C55.843 11.0239 53.8909 12.293 51.2554 12.293C47.9652 12.293 45.74 10.315 45.74 7.40512C45.74 4.49524 47.9652 2.51729 51.2554 2.51729C53.9239 2.51729 55.8918 3.81836 56.5403 5.86245H59.0905ZM67.838 0.57737H65.1564L58.1955 14.2329H60.8011L62.5318 10.8095H70.4626L72.1933 14.2329H74.7798L67.838 0.57737ZM63.6158 8.67938L66.5067 2.97374L69.3975 8.67938H63.6158ZM78.0382 0.57737H75.6038V14.2329H88.004V12.1028H78.0382V0.57737ZM91.5577 0.57737H89.1233V14.2329H101.523V12.1028H91.5577V0.57737Z'
      fill='#0D0D0E'
    />
    <rect
      x='108.816'
      y='0.325456'
      width='39.3673'
      height='14.16'
      rx='7.08001'
      stroke='#0D0D0E'
      strokeWidth='0.650912'
    />
    <path
      d='M115.723 10.9055V4.33079L118.333 4.33079C119.743 4.33079 120.494 4.94431 120.494 6.06146C120.494 6.87644 120.018 7.29766 119.56 7.4808C120.247 7.70057 120.705 8.2683 120.705 9.07412C120.705 10.2279 119.853 10.9055 118.498 10.9055H115.723ZM116.85 7.05042H118.223C118.974 7.05042 119.386 6.7574 119.386 6.18051C119.386 5.60361 118.974 5.31975 118.223 5.31975H116.85V7.05042ZM116.85 8.03938V9.91656H118.434C119.176 9.91656 119.579 9.53197 119.579 8.97339C119.579 8.42397 119.176 8.03938 118.434 8.03938H116.85ZM122.945 4.33079L127.396 4.33079V5.35638H124.099V7.00464H126.874V8.03022H124.099V9.87993H127.396V10.9055L122.945 10.9055V4.33079ZM134.673 5.35638L132.558 5.35638V10.9055H131.386V5.35638L129.27 5.35638V4.33079L134.673 4.33079V5.35638ZM137.989 4.33079H139.317L141.808 10.9055H140.627L140.059 9.40377H137.22L136.662 10.9055H135.499L137.989 4.33079ZM138.63 5.63109L137.605 8.37819H139.674L138.63 5.63109Z'
      fill='#0D0D0E'
    />
  </svg>
)
